import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ShareView from "./pages/ShareView";
import './App.css'; 


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/share/:compaign_id" element={<ShareView />} />
        <Route path="/download/:compaign_id" element={<ShareView />} />
      </Routes>
    </Router>
  );
}

export default App;
